// ProductionFormLogic.js
import { defineComponent } from "vue";
import { db } from "../firebaseConfig";
import { collection, addDoc, setDoc, doc, getDocs } from "firebase/firestore";

export default defineComponent({
  name: "ProductionForm",
  data() {
    return {
      form: {
        projectName: "",
        producers: [], // Array of selected producer IDs
        productionTimeframe: "", // Date string from input type="date"
        initialBrief: ""
      },
      availableProducers: [],
      producerSearchTerm: "",
      error: "",
      loading: false
    };
  },
  async created() {
    await this.fetchProducers();
  },
  computed: {
    filteredProducers() {
      if (!this.producerSearchTerm) return this.availableProducers;
      const term = this.producerSearchTerm.toLowerCase();
      return this.availableProducers.filter(producer =>
        producer.name.toLowerCase().includes(term)
      );
    }
  },
  methods: {
    // Fetch producers from /users collection. Optionally, filter by role if needed.
    async fetchProducers() {
      try {
        const qSnap = await getDocs(collection(db, "users"));
        let producers = [];
        qSnap.forEach(docSnap => {
          const data = docSnap.data();
          // Uncomment the following line to restrict to role "producer":
          // if (data.role !== "producer") return;
          producers.push({
            id: docSnap.id,
            name: `${data.firstName} ${data.surname}`
          });
        });
        // Sort producers alphabetically by name
        producers.sort((a, b) => a.name.localeCompare(b.name));
        this.availableProducers = producers;
      } catch (err) {
        console.error("Error fetching producers:", err);
        this.error = "Error fetching producers.";
      }
    },

    // Called when a producer is selected from the dropdown.
    selectProducer(producerId) {
      if (!this.form.producers.includes(producerId)) {
        this.form.producers.push(producerId);
      }
    },

    // Remove a selected producer.
    removeProducer(index) {
      this.form.producers.splice(index, 1);
    },

    // Submit the form to create a new project feedback page.
    async submitProject() {
      try {
        this.loading = true;
        // Create a new project document in the "projects" collection
        const projectRef = await addDoc(collection(db, "projects"), {
          createdAt: new Date()
        });
        const projectId = projectRef.id;

        // Create the projectDetails sub-document under this project.
        await setDoc(doc(db, "projects", projectId, "projectDetails", "details"), {
          projectName: this.form.projectName,
          producers: this.form.producers,
          productionTimeframe: this.form.productionTimeframe, // Optional
          initialBrief: this.form.initialBrief,               // Optional
          createdAt: new Date()
        });

        this.loading = false;
        // Redirect to the dedicated feedback page using the projectId as slug.
        this.$router.push(`/feedback/${projectId}`);
      } catch (err) {
        console.error("Error submitting project:", err);
        this.error = "Error submitting project.";
        this.loading = false;
      }
    }
  }
});
